export const getMappedValue = (value, map, type) => {
	const foundValue = map[value];
	const mappedValue = typeof foundValue === 'object'
		? foundValue[type]
		: foundValue;

	return mappedValue || 'N/A';
};
